import { render, staticRenderFns } from "./Evo.vue?vue&type=template&id=45765840&"
import script from "./Evo.vue?vue&type=script&lang=js&"
export * from "./Evo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports